export const transformCookieNames = (name: string) => {
  const cookie: { [key: string]: string } = {
    'uID': 'uID',
    'dar': 'darId',
    's_fid': 'adobeAnalyticsFallbackId',
    's_vi': 'adobeAnalyticsVisitorId',
    's_ecid': 'adobeExperienceCloudId',
    'AMCV_121534B8527830F30A490D44@AdobeOrg': 'adobeExperienceVisitorCloudId',
    'AMCV_121534B8527830F30A490D44%40AdobeOrg': 'adobeExperienceVisitorCloudId',
    'kndctr_121534B8527830F30A490D44_AdobeOrg_identity': 'abobeEcidId',
    'gclid': 'googleClickId',
    '_evga_52cd': 'salesforcePersonalizationId1',
    '_evga_d0db': 'salesforcePersonalizationId2',
    '_fbp': 'facebookBrowserId',
  };
  return cookie[name];
};

/**
 * format the consent cookie 
 * 
 * @function
 * @name transformCookieToObj
 * @returns {obj} | false -  the consent cookie does not exist return false else return the formatted obj
 */

export const transformCookieToObj = (queryString: string) => {
  if(queryString){
    const obj = Object.fromEntries(new URLSearchParams(queryString));
    let groups:string = '';
    const parseGroups = (groupsStr: string) =>
      Object.fromEntries(
        groupsStr.split(',').map((pair) => {
          const [key, value] = pair.split(':');
          if(value === '1') groups += ','+key;
          return [key, value === '1' ? 'Opted-in' : 'Opted-out'];
        }),
      );
      console.log('obj', obj);
      if(obj?.groups){
        const newGroup = parseGroups(obj.groups);

        console.log(groups.substring(1))
        return { date: obj.datestamp, groups: newGroup, output:groups.substring(1) };
      }
  }
  return false;
};
